import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PlanListEntry from 'Components/AdvisorApp/Viewport/Household/Plan/Home/PlanListEntry';
import { convertResourceToPlan } from 'Helpers/Plan';
import { displayErrorMessage, displaySuccess } from '../../../Helpers/FacetNotificationManager';

// TODO: find a way to avoid `!important` calls in styles.
const styles = theme => ({
  root: {
    width: '100%',
  },
  linkText: {
    fontSize: theme.typography.h4.fontSize,
    color: theme.palette.primary.main,
  },
  lastModified: {
    fontSize: `${theme.typography.h4.fontSize} !important`,
    color: theme.palette.facet.primaryGray,
  },
  remove: {
    textAlign: 'right !important',
  },
  listEntry: {
    height: '35px',
  },
});


const PlaybookPlanDisplay = ({
  className,
  classes,
  plansCollection,
  fetchData,
  householdId,
}) => {
  const onDelete = async (id, remove) => {
    try {
      await remove(id);
      await fetchData();
      displaySuccess('Successfully deleted plan');
    } catch (e) {
      displayErrorMessage(e, 'Error when deleting plan');
    }
  };
  const convertedPlans = plansCollection?.resources().list().map((res) => {
    const convertedPlan = convertResourceToPlan(res, householdId);
    if (res.relationship('iconSrc')) {
      return {
        iconSrcOverride: res.relationship('iconSrc').link('related').url(),
        ...convertedPlan,
      };
    }
    return convertedPlan;
  });

  return (
    <table className={classNames(classes.root, className)}>
      <tbody>
        {convertedPlans?.map(plan => (
          <PlanListEntry
            {...plan}
            classes={{
              root: classes.listEntry,
              linkText: classes.linkText,
              lastModified: classes.lastModified,
              remove: classes.remove,
            }}
            onDelete={onDelete}
          />
        ))}
      </tbody>
    </table>
  );
};

PlaybookPlanDisplay.defaultProps = {
  className: '',
};

PlaybookPlanDisplay.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  plansCollection: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
  householdId: PropTypes.string.isRequired,
};

export default withStyles(styles)(PlaybookPlanDisplay);
